<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>种草活动</span>
    </div>
    <el-collapse accordion>
        <el-collapse-item title="种草活动有什么益处？" name="1">
            <p>种草活动是摩点为商家提供的站外破圈工具，核心是借助用户生成的内容，在站外吸引更多目标用户关注，进而扩大项目及发起人的影响力。</p>
        </el-collapse-item>
        <el-collapse-item title="种草活动的流程是什么？" name="2">
            <el-image 
                class="pc-image"
                style="margin: 15px 0 0 0;"
                :src="rednoteStep"
                :preview-src-list="imageList"
                :initial-index="0"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
        </el-collapse-item>
        <el-collapse-item title="奖励类型可以设置哪些？" name="3">
            <ul class="circle">
                <li>奖品：实物奖品、虚拟奖品（如返现券，半价券等）</li>
                <li>购买权：用于抽取购买资格；仅向中奖用户开放购买权，一般针对限量商品</li>
                <li>活动审核：用于审核参与某活动资格；用户需完成种草活动且通过审核后，方可参与某个活动，如抽奖</li>
            </ul>
        </el-collapse-item>
        <el-collapse-item title="如何设置种草活动？" name="5">
            <p style="font-weight: 600;">1.电脑端「项目管理后台」—「抽奖&种草」—「创建小红书种草」；</p>
            <el-image 
                class="enlarged pc-image"
                :src="rednote1"
                :preview-src-list="imageList"
                :initial-index="1"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p style="padding: 60px 0 0 0;font-weight: 600;">2.添加种草活动标题，选择该活动关联的众筹项目；</p>
            <el-image 
                class="enlarged pc-image"
                :src="rednote2"
                :preview-src-list="imageList"
                :initial-index="2"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p style="padding: 60px 0 0 0;font-weight: 600;">3.添加奖励类型：奖品/购买权/活动审核</p>
            <ul class="circle">
                <li>
                    <strong>奖励类型：奖品</strong>
                    <p>点击「添加奖品」，选择或者上传奖品并保存，奖品可以是虚拟产品也可以是实物产品；</p>
                </li>
            </ul>
            <el-image 
                class="enlarged pc-image"
                :src="rednote3"
                :preview-src-list="imageList"
                :initial-index="3"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p style="padding: 60px 0 0 0;">设置活动开始、结束时间，填写参与要求（用于提示用户写笔记的描写方向、突出内容特点与核心重点，说明最想展现的亮点等）及评选规则；</p>
            <el-image 
                class="enlarged pc-image"
                :src="rednote4"
                :preview-src-list="imageList"
                :initial-index="4"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <div class="rednote_tips">
                <ul class="circle">
                    <li>笔记要求：</li>
                    <ul class="no">
                        <li>笔记需包含“xxxxx（项目关键词）”字样，针对项目的亮点和特色（可以从xx方向展开描述）</li>
                        <li>发布笔记时，请带话题【# 摩点众筹】【# 项目关键词】</li>
                        <li>完成后上传截图（本次更新底部「提交凭证」），活动结束后，在更新中公示中奖者</li>
                    </ul>
                    <li>评选规则（可单选也可多选）:</li>
                    <ul class="no">
                        <li>热度奖：活动结束后，根据笔记点赞数与评论数进行排名，前10名发布者获得对应奖品</li>
                        <li>幸运奖：在成功参与活动的用户中，随机抽取20人发放奖品</li>
                        <li>伙伴奖：将笔记反馈回摩点并通过审核的参与者，均可获得一份奖品</li>
                    </ul>
                </ul>
            </div>
            <ul class="circle">
                <li>
                    <strong>奖励类型：购买权（用于抽取购买资格）</strong>
                    <p>奖励类型选择「购买权」，点击「添加商品」选择回报档，并确定，设置活动开始、结束时间；</p>
                    <el-image 
                        class="enlarged pc-image"
                        :src="rednote5"
                        :preview-src-list="imageList"
                        :initial-index="5"
                        :preview-teleported="true"
                        fit="contain"
                        loading="lazy"
                    />
                </li>
            </ul>
            <p style="padding: 60px 0 0 0;">填写参与要求（用于提示用户写笔记的描写方向、突出内容特点与核心重点，说明最想展现的亮点等）及评选规则；</p>
            <el-image 
                class="enlarged pc-image"
                :src="rednote6"
                :preview-src-list="imageList"
                :initial-index="6"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <div class="rednote_tips">
                <ul class="circle">
                    <li>笔记要求：</li>
                    <ul class="no">
                        <li>笔记需包含“xxxxx（项目关键词）”字样，针对项目的亮点和特色（可以从xx方向展开描述）</li>
                        <li>发布笔记时，请带话题【# 摩点众筹】【# 项目关键词】</li>
                        <li>完成后上传截图（本次更新底部「提交凭证」），活动结束后，在更新中公示中奖者</li>
                    </ul>
                    <li>评选规则（任选1个开奖规则并在页面说明）:</li>
                    <ul class="no">
                        <li>按笔记互动量，前x名的用户，可以获得购买权益；</li>
                        <li>在参与活动的用户中随机抽取；</li>
                    </ul>
                </ul>
            </div>
            <ul class="circle">
                <li>
                    <strong>奖励类型：活动审核（用于审核参与某活动资格）</strong>
                    <p>奖励类型选择「活动审核」，设置活动时间，填写参与要求及评选规则（此玩法仅支持人工审核）；</p>
                </li>
            </ul>
            <el-image 
                class="enlarged pc-image"
                :src="rednote7"
                :preview-src-list="imageList"
                :initial-index="7"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <div class="rednote_tips">
                <ul class="circle">
                    <li>笔记要求：</li>
                    <ul class="no">
                        <li>笔记需包含“xxxxx（项目关键词）”字样，针对项目的亮点和特色（可以从xx方向展开描述）</li>
                        <li>发布笔记时，请带话题【# 摩点众筹】【# 项目关键词】</li>
                        <li>完成后上传截图（本次更新底部「提交凭证」）</li>
                    </ul>
                    <li>评选规则：</li>
                    <ul class="no">
                        <li>提交笔记截图的x天内完成审核，通过审核的用户，可以参加xxx活动，活动具体权益：xxxxxxx</li>
                    </ul>
                </ul>
            </div>
            <ul class="circle">
                <li>
                    <strong>填写素材及开奖规则（可选系统开奖或人工开奖）发奖时间等信息，保存并发布，种草活动就设置好啦</strong>
                </li>
            </ul>
            <el-image 
                class="enlarged pc-image"
                :src="rednote8"
                :preview-src-list="imageList"
                :initial-index="8"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <el-button style="margin: 40px 0 0 0;" type="primary" @click="handleGoRednote">去发布种草活动</el-button>
        </el-collapse-item>
    </el-collapse>
</template>

<script setup>
import { useRouter } from 'vue-router'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const rednoteStep = `${CDN_BASE}rednote_step.png`
const rednote1 = `${CDN_BASE}rednote_1.png`
const rednote2 = `${CDN_BASE}rednote_2.png`
const rednote3 = `${CDN_BASE}rednote_3.png`
const rednote4 = `${CDN_BASE}rednote_4.png`
const rednote5 = `${CDN_BASE}rednote_5.png`
const rednote6 = `${CDN_BASE}rednote_6.png`
const rednote7 = `${CDN_BASE}rednote_7.png`
const rednote8 = `${CDN_BASE}rednote_8.png`

// 图片列表，用于预览
const imageList = [rednoteStep, rednote1, rednote2, rednote3, rednote4, rednote5, rednote6, rednote7, rednote8]
const router = useRouter()
const handleGoRednote = () => {
    router.push((`/operate_manage/drawtool/create_rednote`))
}
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}
</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    margin: 0 0 40px 0;
    position: relative;
    .el-button{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.el-collapse{
    border:none;
    ::v-deep(.el-collapse-item){
        padding: 0 0 40px 0;
    }
    ::v-deep(.el-collapse-item__wrap){
        border:none;
        .el-collapse-item__content{
            padding: 0;
        }
    }
    ::v-deep(.el-collapse-item__header){    
        border:none;
        font-size: 24px;
        color: #1A1A1A;
        font-weight: 600;
        line-height: 24px;
    }
}
.el-collapse{
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    &.img{
        .title{
            margin: 0;
        }
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    .tab_title{
        font-weight: 600;
    }
    .tab_tips{
        display: flex;
        align-items: center;
        margin: 10px 0 0 0;
        .item{
            width: 200px;
            margin: 0 30px 0 0;
            p{
                font-weight: 600;
                font-size: 14px;
                line-height: 1;
                margin: 0 0 30px 0;
            }
            .el-image {
                width: 100%;
                height: auto;
                cursor: pointer;
                
                &.enlarged {
                    transform: scale(1.2);
                    transform-origin: center;
                    transition: transform 0.3s ease;
                }
            }
        }
    }
    .rednote_tips{
        margin: 30px 0 0 0;
        width: 667px;
        padding: 30px 24px;
        border-radius: 8px;
        background: #F7F7F7;
    }
    p{
        font-size: 14px;
        line-height: 21px;
        span{
            font-weight: 600;
        }
    }
    img{
        width: 100%;
        height: auto;
    }
    .el-image {
        height: auto;
        cursor: pointer;
        
        &.enlarged {
            transform: scale(1.2);
            transform-origin: center;
            transition: transform 0.3s ease;
        }
        
        &.pc-image {
            width: 667px;
            margin:40px 0 0 40px;
        }
        
        &.app-image {
            width: 230px;
            margin:20px 0 0 0;
        }
    }
    ul{
        padding: 0 0 0 20px;
        line-height: 21px;
        li{
            font-size: 14px;
            line-height: 21px;
            strong{
                line-height: 1;
                display: block;
                padding: 20px 0 10px 0;
                font-weight: 600;
            }
        }
        ul{
            padding: 0;
        }
        
        &.no{
            list-style-type: decimal !important;
            li{
                list-style: decimal !important;
            }
        }
        
        &.circle{
            list-style-type: disc !important;
            li{
                list-style: disc;
            }
        }
    }
}
</style>